import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  createFormatShortDate,
  type FormatShortDate
} from './createFormatShortDate';

/** Locale-aware short date formatting via the active i18n language. */
export function useFormatShortDate(): FormatShortDate {
  const { i18n } = useTranslation();
  const locale = i18n.language;

  return useMemo(() => createFormatShortDate(locale), [locale]);
}
